import { createReducer } from "redux-create-reducer";

import {
  UPLOAD_SCORE_CARD,
  GET_LAST_SCORE_CARD,
} from "../types/scoreCardTypes";

const initialState = {
  scFile: [],
  lastScoreCard: {},
  isLoading: false,
  isLoadingGetScoreCards: false,
};

const scoreCardsReducer = createReducer(initialState, {
  [UPLOAD_SCORE_CARD.DEFAULT]: (state, { payload }) => ({
    ...state,
    isLoading: true,
  }),
  [UPLOAD_SCORE_CARD.PENDING]: (state, { payload }) => ({
    ...state,
    isLoading: true,
  }),
  [UPLOAD_SCORE_CARD.REJECTED]: (state, { payload }) => ({
    ...state,
    isLoading: false,
  }),
  [UPLOAD_SCORE_CARD.FULFILLED]: (state, { payload }) => ({
    ...state,
    scFile: payload.data,
    isLoading: false,
  }),
  [GET_LAST_SCORE_CARD.DEFAULT]: (state, { payload }) => ({
    ...state,
    isLoadingGetScoreCards: true,
  }),
  [GET_LAST_SCORE_CARD.PENDING]: (state, { payload }) => ({
    ...state,
    isLoadingGetScoreCards: true,
  }),
  [GET_LAST_SCORE_CARD.REJECTED]: (state, { payload }) => ({
    ...state,
    isLoadingGetScoreCards: false,
  }),
  [GET_LAST_SCORE_CARD.FULFILLED]: (state, { payload }) => ({
    ...state,
    isLoadingGetScoreCards: false,
    lastScoreCard: payload.data,
  }),
});

export default scoreCardsReducer;



// WEBPACK FOOTER //
// ./src/features/score-card/reducers/scoreCardsReducer.js